import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface MigrationMode {
  isActive: boolean;
  source: 'production' | 'staging';
  lastSyncDate: Date | null;
  validationStatus: 'pending' | 'validated' | 'error';
  validationErrors: string[];
}

interface MigrationStore extends MigrationMode {
  // Actions
  enableMigrationMode: () => void;
  disableMigrationMode: () => void;
  updateValidationStatus: (status: 'pending' | 'validated' | 'error', errors?: string[]) => void;
  updateLastSyncDate: (date: Date) => void;
}

export const useMigrationStore = create<MigrationStore>()(
  persist(
    (set) => ({
      // État initial
      isActive: false,
      source: 'production',
      lastSyncDate: null,
      validationStatus: 'pending',
      validationErrors: [],

      // Actions
      enableMigrationMode: () => set({ 
        isActive: true, 
        source: 'staging',
        validationStatus: 'pending',
        validationErrors: []
      }),
      
      disableMigrationMode: () => set({ 
        isActive: false, 
        source: 'production',
        validationStatus: 'pending',
        validationErrors: []
      }),
      
      updateValidationStatus: (status, errors = []) => set({ 
        validationStatus: status,
        validationErrors: errors
      }),
      
      updateLastSyncDate: (date) => set({ lastSyncDate: date })
    }),
    {
      name: 'migration-mode-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isActive: state.isActive,
        source: state.source,
        lastSyncDate: state.lastSyncDate,
        validationStatus: state.validationStatus
      })
    }
  )
); 